import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 29"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#22303E",
      d: "M24 15.384c0 6.623-6.237 11.34-9.131 13.172a2.71 2.71 0 0 1-2.899.022C9.104 26.809 3 22.238 3 15.384 3 9.649 7.701 5 13.5 5S24 9.649 24 15.384"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "13.5",
      cy: "15.667",
      fill: "currentColor",
      rx: "8.403",
      ry: "8.533"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#22303E",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.248",
      d: "m9.449 14.91 3.122 2.688 4.98-4.516"
    }, null, -1)
  ]))]))
}
export default { render: render }